import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";

const DispatchOfVehicles = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIn, setShowGateIn] = useState(false);
  const [date, setDate] = useState(new Date().toISOString());
  const [vehicleNo, setVehicleNo] = useState("");
  const [dispatchNo, setDispatchNo] = useState("");
  const [latestDispatchNo, setLatestDispatchNo] = useState("");
  const [firstDispatchNo, setFirstDispatchNo] = useState("");
  const [loadingOrderNo, setLoadingOrderNo] = useState("");
  const [dipatchNotes, setDispatchNotes] = useState("");
  const [millNo, setMillNo] = useState("");
  const [productList, setProductsList] = useState([]);
  const [millNoSearch, setMillNoSearch] = useState("");
  const [locationList, setLocationList] = useState([]);
  const [invoiceNo, setInvoiceNo] = useState("");
  const [orderNo, setOrderNo] = useState("");
  const [dispatchLocations, setDispatchLocations] = useState("");
  const [hist, setHist] = useState(false);

  const [currentTime, setCurrentTime] = useState(
    new Date().toTimeString().slice(0, 5),
  );

  const [driversList, setDriversList] = useState([]);
  const [driverName, setDriverName] = useState("");
  const [weighInData, setWeighInData] = useState([]);

  const [histData, setHistData] = useState([]);
  const [showHist, setShowhist] = useState(false);
  const [searchHist, setSearchHist] = useState("");
  const [startDateHist, setStartDateHist] = useState("");
  const [endDateHist, setEndDateHist] = useState("");

  const VehicleDepartment = useSelector(
    (state) => state?.VehicleDepartmentReducer,
  );

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentTime(new Date().toLocaleTimeString());
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, []);

  const filteredData = vehiclesList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0 && !millNoSearch) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "VEHICLE REG NO",
        "DRIVER NAME",
        "MAKE",
        "MODEL",
        "ATTACHED NAME TRAILER",
        "DISPATCH LOCATION",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    const millNoFilter =
      !millNoSearch ||
      String(item?.["DISPATCH LOCATION"] || "")
        .toLowerCase()
        .includes(millNoSearch.toLowerCase());

    return textMatch && millNoFilter;
  });

  const filtHist = histData?.filter((item) => {
    const searchData = searchHist?.toLowerCase().split(" ").filter(Boolean);
    const sDate = new Date(item.OT_DISPATCH_DATE);
    const eDate = new Date(item.OT_DISPATCH_DATE);
    const startDate = startDateHist ? new Date(startDateHist) : null;
    const endDate = endDateHist ? new Date(endDateHist) : null;

    const textMatch = searchData.every((term) => {
      const otherMatch = [
        "OT_DISPATCH_NO",
        "OT_DISPATCH_LOADING_ORDER_NO",
        "OT_DISPATCH_VEHICLE_REG_NO",
        "OT_DISPATCH_NOTES",
        "OT_DISPATCH_INV_NO",
        "OT_DISPATCH_MILL_NO",
      ].some((key) => {
        const columnValue = String(item[key] || "").toLowerCase();
        return columnValue.includes(term);
      });

      return otherMatch;
    });

    const dateMatch =
      (!startDate || sDate >= startDate) && (!endDate || eDate <= endDate);

    return textMatch && dateMatch;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1088`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDispatchNo(response?.data[0]?.NEW_DISPATCH_NO);
        setLatestDispatchNo(response?.data[0]?.NEW_DISPATCH_NO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });

    // Driver's List  345;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriversList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1291`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setLocationList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Location List details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=625`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data?.filter(
          (item) => item.OM_ITEM_FINISHED_RAW_MATERIAL === "F",
        );
        setProductsList(filter);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Item Details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1228`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data?.filter(
          (item) => item?.SECONDWEIGHT === null,
        );
        setWeighInData(filter);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Weigh in details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1089`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const sortedData = response?.data?.sort(
          (a, b) => a?.OT_DISPATCH_NO - b?.OT_DISPATCH_NO,
        );
        setFirstDispatchNo(sortedData[0]?.OT_DISPATCH_NO);
        setHistData(sortedData);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Weigh in details 1333:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1333`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setVehiclesList(response?.data);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Weigh in details 1333:", error);
      });
  };

  async function getNewDispatchNo() {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1088`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDispatchNo(response?.data[0]?.NEW_DISPATCH_NO);
        setLatestDispatchNo(response?.data[0]?.NEW_DISPATCH_NO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });
  }

  // Saving
  async function SaveGateIn() {
    // await axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1089`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then(async (response) => {
    //     const sortedData = [...(response?.data || [])].sort(
    //       (a, b) => Number(b.OT_DISPATCH_NO) - Number(a.OT_DISPATCH_NO),
    //     );
    //     const isDispatchAvailable = sortedData?.find(
    //       (item) => item?.OT_DISPATCH_NO === Number(dispatchNo),
    //     );
    //     if (
    //       isDispatchAvailable &&
    //       sortedData[0]?.OT_DISPATCH_NO > latestDispatchNo
    //     ) {
    //       await getNewDispatchNo();
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching Header Details 1089:", error);
    //   });

    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1090`,
        {
          OT_DISPATCH_NO: Number(dispatchNo),
          OT_DISPATCH_LOADING_ORDER_NO: Number(loadingOrderNo),
          OT_DISPATCH_VEHICLE_REG_NO: vehicleNo ? vehicleNo : "",
          OT_DISPATCH_MILL_NO: dispatchLocations ? dispatchLocations : "",
          OT_DISPATCH_DATE: moment(date).format("YYYY/MM/DD"),
          OT_DISPATCH_TIME: currentTime,
          OT_DISPATCH_NOTES: dipatchNotes ? dipatchNotes : "",
          OT_DISPATCH_PROCESSED_BY: user,
          OT_DISPATCH_INV_NO: invoiceNo ? Number(invoiceNo) : 0,
          OT_DISPATCH_NEW_EXISTING: hist === true ? "EXISTING" : "NEW",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        const vehicleData = vehiclesList?.filter(
          (item) => item?.["VEHICLE REG NO"] === vehicleNo,
        );

        // if (vehicleData?.length === getRes?.data?.length) {
        if (vehicleData?.length === 1) {
          const weighBridge = weighInData?.find(
            (item) => item?.TRUCKNO === vehicleNo,
          );
          if (!weighBridge) {
            await SaveVehicleState(response?.data?.message);
          } else {
            alert(`Vehicle Dispatched successfully`);
          }
        } else {
          alert(`Vehicle Dispatched successfully`);
        }

        setisloading(false);

        // await SaveVehicleState();
      } else {
        setisloading(false);
        console.error(`Error while Dispatching Vehicle`);
        alert(`Error while Dispatching Vehicle`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while Dispatching Vehicle`, error);
      alert(`Error while Dispatching Vehicle`, error);
    }
  }

  async function SaveVehicleState(docNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1053`,
        {
          OT_VEHICLE_REG_NO: vehicleNo,
          OT_VEHICLE_STATE: "DISPATCHED",
          OT_VEHICLE_STATE_DATE: moment(date).format("YYYY/MM/DD"),
          OT_VEHICLE_STATE_TIME: currentTime,
          OT_VEHICLE_PREVIOUS_STATE: "SEND TO DISPATCH",
          OT_VEHICLE_STATE_UPDATED_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        // setisloading(false);
        await SaveState(docNo);

        // console.log(`Vehicle State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Vehicle State`);
        alert(`Error while saving Vehicle State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Vehicle State `, error);
      alert(`Error while saving Vehicle State `, error);
    }
  }

  async function SaveState(docNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1121`,
        {
          TRANSTYPE: "DISPATCHED",
          DOC_NO: Number(docNo),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Vehicle Dispatched successfully`);
        // alert(`State Updated successfully`);
        console.log(`State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving State`);
        alert(`Error while saving State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving State `, error);
      alert(`Error while saving State `, error);
    }
  }

  function fetchLoadingOrderNo(vehicle) {
    //   For Last Gate In No
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1095`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data?.filter(
          (item) => item.OT_LOADING_ADVISE_VEHICLE_NO === vehicle,
        );
        setLoadingOrderNo(filter[filter?.length - 1]?.OT_LOADING_ADVISE_NO);
        setOrderNo(filter[filter?.length - 1]?.OT_LOADING_ADVISE_CLIENT_PO_NO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Verification Data:", error);
      });
  }

  const handleRowClick = async (value, index) => {
    setDriverName(value["DRIVER NAME"]);
    setVehicleNo(value["VEHICLE REG NO"]);
    setDispatchLocations(value?.["DISPATCH LOCATION"] || "");
    setLoadingOrderNo(value?.["DOC NO"] || 0);
    setOrderNo(value?.["ORDER NO"] || "");
    // fetchLoadingOrderNo(value["VEHICLE REG NO"]);
    setShowGateIn(true);
  };

  const handleButtonClick = (action) => {
    let dispatchNoToPass;
    switch (action) {
      case "first":
        dispatchNoToPass = Number(firstDispatchNo);
        break;
      case "decrement":
        dispatchNoToPass = Number(dispatchNo) - 1;
        if (dispatchNoToPass < Number(firstDispatchNo)) {
          alert("Cannot decrement further");
          return;
        }
        break;

      case "increment":
        dispatchNoToPass = Number(dispatchNo) + 1;
        if (dispatchNoToPass >= Number(latestDispatchNo)) {
          alert("No Further PO number");
          return;
        }
        break;

      case "latest":
        dispatchNoToPass = Number(latestDispatchNo) - 1;
        break;
      default:
        break;
    }

    setDispatchNo(dispatchNoToPass);
    getNavData(dispatchNoToPass);
  };

  async function getNavData(dispatch) {
    const item = histData?.find((value) => value?.OT_DISPATCH_NO === dispatch);

    if (item) {
      setDispatchNo(item?.["OT_DISPATCH_NO"]);
      setLoadingOrderNo(item?.["OT_DISPATCH_LOADING_ORDER_NO"]);
      setVehicleNo(item?.["OT_DISPATCH_VEHICLE_REG_NO"]);
      setDate(item?.["OT_DISPATCH_DATE"]);
      setCurrentTime(
        item?.["OT_DISPATCH_TIME"]
          ? item?.["OT_DISPATCH_TIME"]?.split("T")[1]?.slice(0, 5)
          : "",
      );
      setDispatchNotes(item?.["OT_DISPATCH_NOTES"]);
      setInvoiceNo(item?.["OT_DISPATCH_INV_NO"]);
      setHist(true)
    } else {
      // Auto-decrement if record not found
      const allVouchers = [...(histData || [])]
        .map((item) => Number(item?.OT_DISPATCH_NO))
        .sort((a, b) => a - b);

      const currentDispatch = Number(dispatch);

      // Determine whether this was likely an increment or decrement action
      const lastDispatchNo = Number(dispatchNo);

      const isIncrement = currentDispatch > lastDispatchNo;

      if (isIncrement) {
        // Find next existing record greater than the current one
        const nextExisting = allVouchers.find((num) => num > currentDispatch);
        if (nextExisting !== undefined) {
          console.warn(
            `Dispatch No ${dispatch} not found, trying ${nextExisting}`,
          );
          await getNavData(nextExisting);
          return;
        } else {
          alert(`No further Dispatch No found after ${dispatch}`);
        }
      } else {
        const previousExisting = [...allVouchers]
          .reverse()
          .find((num) => num < Number(dispatch));

        if (previousExisting !== undefined) {
          console.warn(
            `Dispatch No ${dispatch} not found, trying ${previousExisting}`,
          );
          await getNavData(previousExisting);
          return;
        } else {
          alert(`No existing Dispatch No found before ${dispatch}`);
        }
      }
    }
  }

  // ********** EXPORT TO PDF AND EXCEL **************
  const ExcelStockData = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Dispatch Of Vehicles");
    const rows = document.querySelectorAll(".table_1 tbody tr");

    const columnWidths = [15, 15, 15, 15, 15, 25, 35, 15];

    // Set column widths for the worksheet
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers
    const headerRow = worksheet.addRow([
      "Dispatch No",
      "Loading Order",
      "Vehicle",
      "Date",
      "Time",
      "Dispatch Location",
      "Notes",
      "Invoice No",
    ]);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Add rows from the table
    rows.forEach((row) => {
      const rowData = [];
      row.querySelectorAll("td").forEach((cell) => {
        rowData.push(cell.textContent);
      });
      worksheet.addRow(rowData);
    });

    // Create a blob from the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Dispatch_Of_Vehicles.xlsx";
      link.click();
    });
  };

  const PdfStockData = () => {
    const doc = new jsPDF();

    doc.text("Dispatch Of Vehicles - Report", 10, 10);

    const columns = [
      "Dispatch No",
      "Loading Order",
      "Vehicle",
      "Date",
      "Time",
      "Dispatch Location",
      "Notes",
      "Invoice No",
    ];

    const data = filtHist.map((stock) => [
      stock.OT_DISPATCH_NO,
      stock.OT_DISPATCH_LOADING_ORDER_NO,
      stock.OT_DISPATCH_VEHICLE_REG_NO,
      stock.OT_DISPATCH_DATE
        ? moment(stock.OT_DISPATCH_DATE).format("DD/MM/YYYY")
        : "",
      stock.OT_DISPATCH_TIME
        ? moment(stock.OT_DISPATCH_TIME).format("hh:MM:ss")
        : "",
      stock.OT_DISPATCH_MILL_NO,
      stock.OT_DISPATCH_NOTES,
      stock.OT_DISPATCH_INV_NO,
    ]);

    doc.autoTable({
      head: [columns],
      body: data,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save("Dispatch_Of_Vehicles.pdf");
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Dispatch Of Vehicles
        </h1>
        {/* <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        /> */}
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
        <p className="text-red-600 lg:ml-2 mr-1">Dispatch Location :</p>
        <Select
          className="lg:w-72 lg:ml-2"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
          }}
          value={
            millNoSearch
              ? { value: millNoSearch, label: millNoSearch }
              : { value: "", label: "Dispatch Location" }
          }
          onChange={(e) => {
            setMillNoSearch(e.value);
          }}
          options={[
            { value: "", label: "Dispatch Location" },
            ...locationList?.map((m) => ({
              value: m.LOCATIONNAME,
              label: m.LOCATIONNAME,
            })),
          ]}
        ></Select>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DOCUMENT NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ORDER NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAKE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MODEL
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DISPATCH LOCATION
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TRAILER ATTACHED ?
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ATTACHED NAME TRAILER
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => {
              return (
                <tr
                  key={index}
                  className="hover:bg-gray-100 cursor-pointer text-[13px]"
                  onClick={() => handleRowClick(value, index)}
                >
                  <td className="py-2 px-4 text-right border border-gray-300">
                    {index + 1}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value["VEHICLE REG NO"] || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value["DRIVER NAME"] || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value?.["DOC NO"] || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value?.["ORDER NO"] || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value.MAKE || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value.MODEL || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value?.["DISPATCH LOCATION"] || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value["TRAILER ATTACHED ?"] === true
                      ? "YES"
                      : value["TRAILER ATTACHED ?"] === false
                        ? "NO"
                        : "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value["ATTACHED NAME TRAILER"] || "N/A"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* PopUp */}
      {showGateIn && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[450px] h-[80%] lg:w-[900px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="text-3xl font-bold flex lg:justify-center justify-start">
            DISPATCH
          </h1>

          <div className="flex lg:ml-2 gap-1 lg:mr-2">
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("first");
              }}
            >
              {"<<"}
            </button>
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("decrement");
              }}
            >
              {"<"}
            </button>
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("increment");
              }}
            >
              {">"}
            </button>
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("latest");
              }}
            >
              {">>"}
            </button>
          </div>

          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Dispatch No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={dispatchNo}
              readOnly
            ></input>
            <button
              className="border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-1 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                setShowhist(true);
              }}
            >
              ...
            </button>

            {showHist && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[400px] h-[80%] lg:w-[870px] w-[95%] p-1 overflow-y-auto">
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Search:</p>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={searchHist}
                    onChange={(e) => {
                      setSearchHist(e.target.value);
                    }}
                  ></input>
                  <p className="text-red-600 lg:ml-2">Start Date:</p>
                  <input
                    className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={startDateHist?.split("T")[0]}
                    onChange={(e) => {
                      setStartDateHist(e.target.value);
                    }}
                  ></input>
                  <p className="text-red-600 lg:ml-2">End Date:</p>
                  <input
                    className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={endDateHist?.split("T")[0]}
                    onChange={(e) => {
                      setEndDateHist(e.target.value);
                    }}
                  ></input>
                </div>
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => setShowhist(false)}
                >
                  Close
                </button>
                <div className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
                  <div className="flex justify-end gap-2">
                    <div className="cursor-pointer">
                      <RiFileExcel2Line onClick={ExcelStockData} size={25} />
                    </div>
                    <div className="cursor-pointer">
                      <BsFileEarmarkPdf onClick={PdfStockData} size={25} />
                    </div>
                  </div>

                  <table className="w-full border border-gray-300 text-sm table_1">
                    <thead className="sticky top-0">
                      <tr className="bg-[#2b3f5c] text-white text-[12px] table-header">
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Dispatch No
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Loading Order
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Vehicle
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Date
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Time
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Dispatch Location
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Notes
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Invoice No
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {filtHist?.map((item, index) => {
                        return (
                          <tr
                            className="hover:bg-gray-100 cursor-pointer text-[13px]"
                            onClick={() => {
                              setDispatchNo(item?.["OT_DISPATCH_NO"]);
                              setLoadingOrderNo(
                                item?.["OT_DISPATCH_LOADING_ORDER_NO"] || "",
                              );
                              setVehicleNo(
                                item?.["OT_DISPATCH_VEHICLE_REG_NO"] || "",
                              );
                              setDate(item?.["OT_DISPATCH_DATE"] || "");
                              setCurrentTime(
                                item?.["OT_DISPATCH_TIME"]
                                  ? item?.["OT_DISPATCH_TIME"]
                                      ?.split("T")[1]
                                      ?.slice(0, 5)
                                  : "",
                              );
                              setDispatchLocations(
                                item?.["OT_DISPATCH_MILL_NO"] || "",
                              );
                              setDispatchNotes(
                                item?.["OT_DISPATCH_NOTES"] || "",
                              );
                              setInvoiceNo(item?.["OT_DISPATCH_INV_NO"] || "");
                              setHist(true)
                              setShowhist(false);
                            }}
                            key={index}
                          >
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {item?.["OT_DISPATCH_NO"]
                                ? item?.["OT_DISPATCH_NO"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {item?.["OT_DISPATCH_LOADING_ORDER_NO"]
                                ? item?.["OT_DISPATCH_LOADING_ORDER_NO"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["OT_DISPATCH_VEHICLE_REG_NO"]
                                ? item?.["OT_DISPATCH_VEHICLE_REG_NO"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["OT_DISPATCH_DATE"]
                                ? moment(item?.["OT_DISPATCH_DATE"]).format(
                                    "DD/MM/YYYY",
                                  )
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["OT_DISPATCH_TIME"]
                                ? moment(item?.["OT_DISPATCH_TIME"]).format(
                                    "hh:MM:ss",
                                  )
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300">
                              {item?.["OT_DISPATCH_MILL_NO"]
                                ? item?.["OT_DISPATCH_MILL_NO"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300">
                              {item?.["OT_DISPATCH_NOTES"]
                                ? item?.["OT_DISPATCH_NOTES"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300">
                              {item?.["OT_DISPATCH_INV_NO"]
                                ? item?.["OT_DISPATCH_INV_NO"]
                                : "NA"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <p className="text-red-600 lg:ml-9">Doc No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={loadingOrderNo}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-2 mr-1">Vehicle :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNo}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-2">Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={date?.split("T")[0]}
              readOnly
            ></input>
          </div>

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Time :</p>
            <input
              className="w-28 h-8 border border-black lg:ml-14 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="time"
              value={currentTime}
              onChange={(e) => setCurrentTime(e.target.value)}
            ></input>
            <p className="text-red-600 lg:ml-2">Driver :</p>
            <Select
              className="lg:w-64 w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                driverName
                  ? { value: driverName, label: driverName }
                  : { value: "", label: "Select Driver" }
              }
              onChange={(e) => {
                setDriverName(e.label);
                // setDriverCode(e.value);
              }}
              options={[
                { value: "", label: "Select Driver" },
                ...driversList?.map((item) => ({
                  value: item.DRIVERNAME,
                  label: item.DRIVERNAME,
                })),
              ]}
            ></Select>
            <p className="text-red-600 lg:ml-2">Order No:</p>
            <input
              className="w-64 text-right h-8 border border-black lg:ml-1 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={orderNo}
              readOnly
            ></input>
          </div>
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Invoice No:</p>
            <input
              className="w-64 h-8 border border-black lg:ml-4 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={invoiceNo}
              onChange={(e) => setInvoiceNo(e.target.value)}
            ></input>
            <p className="text-red-600 lg:ml-2">Dispatch Locations :</p>

            <textarea
              rows={2}
              className="lg:w-80 resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={dispatchLocations}
            />
          </div>

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Dispatch Notes :</p>
            <textarea
              rows={2}
              className="lg:w-[600px] resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={dipatchNotes}
              onChange={(e) => setDispatchNotes(e.target.value)}
            ></textarea>
          </div>

          <div className="flex justify-center mt-5">
            <button
              className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                if (!invoiceNo) {
                  alert("Kindly Supply Invoice No");
                  return;
                } else if (!dipatchNotes) {
                  alert("Kindly Supply Dispatch Notes");
                  return;
                } else {
                  // const weighBridge = weighInData?.find(
                  //   (item) => item?.TRUCKNO === vehicleNo,
                  // );

                  // if (weighBridge) {
                  //   alert("This Vehicle is under WeighBridge");
                  //   return;
                  // } else {
                  await SaveGateIn();
                  setShowGateIn(false);
                  window.location.reload();
                  // }
                }
              }}
            >
              DISPATCH
            </button>
          </div>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateIn(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default DispatchOfVehicles;
